export const contactUsFormConstants = {
    RECAPTCHA_REQUEST: 'RECAPTCHA_REQUEST',
    RECAPTCHA_SUCCESS: 'RECAPTCHA_SUCCESS',
    RECAPTCHA_ERROR: 'RECAPTCHA_ERROR',
};